<template>
  <div class="input-group">
    <div class="input-group-prepend">
      <multiselect
        v-model="selected"
        :options="optionsCountries"
        @input="updateMask"
        select-label=""
        selected-label="«"
        deselect-label=""
        :allow-empty="allowEmpty"
        :preselect-first="false"
        label="nome"
        track-by="iso2"
        placeholder=""
        class="country-selector"
      >
        <template slot="singleLabel" slot-scope="{ option }">
          <div class="flag-option">
            <flag :iso="option.iso2" :squared="false" />
            <span class="flag-text">{{ option.nome }}</span>
          </div>
        </template>
        <template slot="option" slot-scope="{ option }">
          <div class="flag-option">
            <flag :iso="option.iso2" :squared="false" />
            <span class="flag-text">{{ option.nome }}</span>
          </div>
        </template>
      </multiselect>
    </div>
    <b-input v-model="phoneNumber" v-mask="phoneMask" :placeholder="phoneMask" />
    <small v-if="phoneInvalid" class="text-danger">{{ $t('Informe um número válido') }}.</small>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import libphonenumber from 'google-libphonenumber';
import Multiselect from 'vue-multiselect';

export default {
  components: {
    Multiselect
  },
  props: {
    phone: {
      default: '',
      type: String
    },
    validate: {
      default: true,
      type: Boolean
    },
    allowEmpty: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      isLoading: false,
      phoneNumber: '',
      optionsCountries: [],
      selected: this.allowEmpty ? null : 'BR',
      phoneMask: this.allowEmpty ? '################' : '(##) #####-####',
      phoneUtil: libphonenumber.PhoneNumberUtil.getInstance(),
      phoneInvalid: false
    };
  },
  watch: {
    phoneNumber() {
      if (!this.validate) {
        this.emitPhone();
        return;
      }
      this.validatePhone();
    },
    phone(value) {
      if (!this.phoneNumber) {
        this.setCountryFromPhone(value);
      }
    }
  },
  created() {
    this.setOptions();
  },
  methods: {
    setCountryFromPhone(phone) {
      if (this.allowEmpty) {
        this.setValue(null);
        return;
      }
      if (!phone) {
        this.setValue('BR');
        return;
      }

      this.phoneMask = '';
      const onlyNumbers = phone.replace(/\D/g, '');

      // Detecta o país pelo código (1, 2 ou 3 primeiros dígitos)
      let country = this.optionsCountries.find((c) => onlyNumbers.startsWith(c.codeCountry));

      if (!country)
        country = this.optionsCountries.find((c) => onlyNumbers.startsWith(onlyNumbers.substring(0, 2)));
      if (!country)
        country = this.optionsCountries.find((c) => onlyNumbers.startsWith(onlyNumbers.substring(0, 1)));

      // Se o país não foi encontrado, usa Brasil por padrão
      if (!country) {
        this.setValue('BR');
        return;
      }

      this.setValue(country.iso2);
      this.$nextTick(() => {
        this.updateMask();
      });

      // Remove o código do país e guarda apenas o número
      const countryCodeLength = String(country.codeCountry).length;
      const numberWithoutCountry = onlyNumbers.substring(countryCodeLength);
      this.phoneNumber = numberWithoutCountry;
    },
    updateMask() {
      if (!this.selected) return;
      this.phoneMask = this.getMaskForCountry(this.selected.iso2);
    },
    getMaskForCountry(countryCode) {
      try {
        const phoneExample = this.phoneUtil.getExampleNumberForType(
          countryCode,
          libphonenumber.PhoneNumberType.MOBILE
        );

        if (phoneExample) {
          const formattedExample = this.phoneUtil.format(phoneExample, libphonenumber.PhoneNumberFormat.NATIONAL);
          return formattedExample.replace(/\d/g, '#');
        }
      } catch (error) {
        console.error('Erro ao obter máscara para o país:', countryCode, error);
      }

      return '################';
    },
    validatePhone() {
      if (!this.phoneNumber || !this.phoneMask) {
        this.phoneInvalid = true;
        return;
      }
      if (this.phoneMask === '################') {
        this.phoneInvalid = false;
        this.emitPhone();
        return;
      }

      const minLength = this.phoneMask.replace(/[^#]/g, '').length;
      const phoneDigits = this.phoneNumber.replace(/\D/g, '').length;

      this.phoneInvalid = phoneDigits < minLength;

      this.emitPhone();
    },
    emitPhone() {
      const fullPhone = this.getFullPhoneNumber();
      if (this.phone !== fullPhone) {
        this.$emit('input', fullPhone, this.phoneInvalid);
      }
    },
    getFullPhoneNumber() {
      if (!this.selected || !this.phoneNumber) return '';

      const countryCode = this.selected.codeCountry;
      const phoneWithoutMask = this.phoneNumber.replace(/\D/g, '');

      return `+${countryCode}${phoneWithoutMask}`;
    },
    setValue(value) {
      const newSelected = this.optionsCountries.find((option) => option.iso2 == value) || null;

      if (this.selected !== newSelected) {
        this.selected = newSelected;
        if (this.phoneNumber) this.emitPhone();
      }
    },
    setOptions() {
      this.isLoading = true;
      let filtro = 'nome IS NOT NULL ';
      this.$atenaList
        .getPaises({ filter: filtro, columns: '*', order: 'nome' })
        .then((res) => {
          let countryList = res.data
            .map((item) => {
              let codeCountry = this.phoneUtil.getCountryCodeForRegion(item.iso2);
              if (codeCountry === 0) return null;
              return {
                iso2: item.iso2,
                nome: ` (+${codeCountry})`,
                codeCountry
              };
            })
            .filter(Boolean)
            .reduce((acc, country) => {
              const existente = acc.find((item) => item.codeCountry === country.codeCountry);

              const prioridadePaises = {
                1: 'US', // Para +1, escolhe os EUA
                44: 'GB', // Para +44, escolhe o Reino Unido
                86: 'CN', // Para +86, escolhe a China
                55: 'BR' // Para +55, escolhe o Brasil
              };

              if (!existente) {
                acc.push(country);
              } else {
                const preferido = prioridadePaises[country.codeCountry];

                // Se o país atual for o preferido, substitui o existente
                if (preferido && country.iso2 === preferido) {
                  acc.splice(acc.indexOf(existente), 1, country);
                }
              }

              return acc;
            }, []);

          countryList.sort((a, b) => a.codeCountry - b.codeCountry);
          if (this.allowEmpty) {
            countryList.unshift({
              iso2: null,
              nome: this.$i18n.t('Sem DDI'),
              codeCountry: null
            });
          }
          this.optionsCountries = countryList;

          this.phone
            ? this.setCountryFromPhone(this.phone)
            : this.allowEmpty
            ? this.setValue(null)
            : this.setValue('BR');

          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
          this.$util.formWarn({
            msgTitle: 'Erro ao Carregar Dados',
            msgContent: 'Entre em contato com o Administrador do Sistema.',
            type: 'error'
          });
        });
    }
  }
};
</script>

<style lang="scss">
.flag-option {
  display: flex;
  align-items: center;
}
.flag-text {
  margin-left: 8px;
}
.country-selector {
  width: 120px;
  min-width: 120px;
  height: 100%;
  display: flex;
  align-items: center;
  background: white;
  border-right: none;
}

.country-selector .multiselect__tags {
  border-right: none;
}

small.text-danger {
  display: block;
  width: 100%;
  margin-top: 4px;
}
</style>
